const UnitsMeasurementEn = {
  'units of measurement': 'Units of measurement'
};

export default UnitsMeasurementEn;
